import { Button, Divider, Flex, Form, Input, Modal } from 'antd'
import { AvailableStepButtons } from 'src/pages/budget/budgetRequests/components/availableStepButtons'
import { useModalRequestsReject } from 'src/pages/budget/budgetRequests/hooks'
import {
  closeModalRequestsReject,
  decideRequestsBatchFx,
} from 'src/pages/budget/budgetRequests/model'
import { ActionStep } from 'src/pages/budget/budgetRequests/types'
import { LinkifiedText, UiText } from 'src/pages/budget/components'
import { REQUIRED_FIELD } from 'src/pages/budget/const'
import { showNotification } from 'src/features/notifications'

type RejectFormValues = {
  comment: string
}

export const ModalRequestsReject = () => {
  const [form] = Form.useForm<RejectFormValues>()
  const modalRequestsReject = useModalRequestsReject()

  if (!modalRequestsReject) return null

  const { items } = modalRequestsReject
  const { id, availableApprovalSteps, description } = items[0]
  const ids = items.map(({ id }) => id)
  const open = Boolean(modalRequestsReject)

  const handleCancel = () => {
    form.resetFields()
    closeModalRequestsReject()
  }

  const handleOk = async ({ stepId }: ActionStep) => {
    try {
      const { comment } = await form.validateFields()
      const selectedStep = availableApprovalSteps.find(
        (candidate) => candidate.id === stepId,
      )
      if (!selectedStep) return
      const skippedIds: number[] = []
      const itemsToReject = items.flatMap((item) => {
        const step = item.availableApprovalSteps.find(
          (candidate) => candidate.teamId === selectedStep.teamId,
        )
        if (!step) skippedIds.push(item.id)
        return step ? [{ id: item.id, stepId: step.id }] : []
      })
      if (skippedIds.length) {
        showNotification({
          type: 'warning',
          message: `Не выбраны для отклонения: №${skippedIds.join(', ')}`,
          description: 'Для этих заявок нет подходящего активного шага.',
        })
      }
      if (!itemsToReject.length) return
      await decideRequestsBatchFx({
        url: '/budget/budget_request/batch_reject',
        body: { items: itemsToReject, comment },
      })
      handleCancel()
    } catch (error) {}

  }

  return (
    <Modal
      title={
        <div style={{ fontSize: 20 }}>
          Отклонить {ids.length > 1 ? 'заявки' : 'заявку'}
        </div>
      }
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>

          <AvailableStepButtons
            id={id}
            approvalSteps={availableApprovalSteps}
            text="Отклонить"
            color="volcano"
            callback={handleOk}
          />
        </Flex>
      }
    >
      <Divider />

      <UiText size={18}>
        Вы уверены, что хотите отклонить {ids.length > 1 ? 'заявки' : 'заявку'}{' '}
        <UiText size={18} strong>
          {' '}
          № {ids.join(', ')} <LinkifiedText text={description} />
        </UiText>
        ? Это действие нельзя будет отменить.
      </UiText>

      <Form form={form} layout="vertical">
        <Form.Item
          name="comment"
          rules={[
            {
              required: true,
              whitespace: true,
              message: REQUIRED_FIELD,
            },
          ]}
          style={{ marginTop: 24 }}
        >
          <Input.TextArea
            rows={3}
            placeholder="Здесь вы можете написать причину отклонения или комментарий"
          />
        </Form.Item>
      </Form>

      <Divider />
    </Modal>
  )
}
